/**
 * Keeps in-stock products ahead of sold-out products in search results.
 * Collection and featured collection ordering is rendered server-side in Liquid.
 */
(() => {
  const productItem = (item) => item.querySelector('[data-libaas-product-card]');
  const isSoldOut = (item) => productItem(item)?.dataset.libaasAvailable === 'false';
  const orderSearchGrid = (grid) => {
    const productItems = Array.from(grid.children).filter(productItem);
    const ordered = [...productItems.filter((item) => !isSoldOut(item)), ...productItems.filter(isSoldOut)];
    productItems.forEach((item, index) => {
      if (item !== ordered[index]) grid.insertBefore(ordered[index], item);
    });
  };
  const run = () => document.querySelectorAll('.template-search .product-grid').forEach(orderSearchGrid);
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      run();
    });
  };
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
